import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-container" }, [
    _createElementVNode("div", {
      ref: "modalRef",
      class: "modal fade",
      id: `modal-${_ctx.id}`,
      tabindex: "-1",
      "aria-labelledby": `modal-${_ctx.id}`,
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "modal-content",
          style: _normalizeStyle([_ctx.noPadding && { backgroundColor: 'transparent' }])
        }, [
          (!_ctx.noHeader)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header"),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false))),
                  class: "modal-close"
                }, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "modal-body",
            style: _normalizeStyle([_ctx.noPadding && { padding: 0 }])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4)
        ], 4)
      ])
    ], 8, _hoisted_1)
  ]))
}